import { useEffect } from "react";
import useUIBp from "../../../../../../Hooks/useUIBoilerplate";
import { UIactions } from "../../../../../../store/slices/UI";
import TextField from "../../../../../UI/GeneralPurpose/SimpleTextField";

const UIText = {
  "es-CL": { label: "Contiene", placeholder: "Palabras clave" },
  "en-US": { label: "Contains", placeholder: "Keywords" },
};

export const ContainsId = "teams-contains";
const id = ContainsId;

const Contains = () => {
  const { dispatch, UI } = useUIBp();
  const filter = UI.filter ?? "";

  useEffect(() => {
    const remainingText = filter
      .replace(/from:\([^)]+\)/g, "") // Remove from:(...)
      .replace(/subject:\([^)]+\)/g, "") // Remove subject:(...)
      .replace(/\bstartDate:\d+-\d+-\d+\b/g, "") // Remove startDate:...
      .replace(/\bendDate:\d+-\d+-\d+\b/g, "") // Remove endDate:...
      .trim(); // Trim any extra spaces

    if (remainingText) {
      dispatch(UIactions.setField({ id, value: remainingText }));
    }
  }, [dispatch, filter]);

  return <TextField clearOnUnmount {...{ id, UIText, size: 12 }} />;
};

export default Contains;
